
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.469 6.383c1.093-.037 1.838-.302 2.234-.797.401-.5.602-1.326.602-2.477V.336h2.289v.383c-.344.088-.568.226-.672.414-.104.187-.156.575-.156 1.164v1.117c0 1.339-.373 2.276-1.118 2.813-.744.53-1.804.807-3.18.828v1.992c0 .65.06 1.055.18 1.21.125.152.37.272.735.36V11h-3.29v-.383c.381-.094.628-.219.743-.375.115-.156.172-.555.172-1.195V7.055c-1.427-.026-2.5-.302-3.219-.828-.713-.532-1.07-1.44-1.07-2.727V2.398c0-.63-.05-1.044-.149-1.242C1.477.953 1.25.807.89.72V.336h2.29v2.773c0 .891.093 1.545.28 1.961.194.417.485.735.876.953.39.22.948.336 1.672.352V2.289c0-.651-.063-1.052-.188-1.203C5.7.93 5.458.807 5.094.719V.336h3.289v.383c-.36.088-.602.205-.727.351-.125.14-.187.547-.187 1.22v4.093z","fill":"currentColor"}})])
          )
        }
      }
    